import type { TemplateBase } from "@expert/expert-university";

import { capitalizeFirstLetter } from "@/shared-utils/formatters/capitalizeFirstLetter";

// TODO: placeholder copy — confirm final titles before ship
export const LEARNING_BLOCK_TITLES: string[] = [
    "Welcome to Asurion",
    "Expert Foundations",
    "Asurion Tools",
    "Client Tools",
    "Sales Foundations",
    "Call Flow Part 1",
    "Troubleshooting",
    "Device Basics",
    "Hardware vs. Software",
    "Networking",
    "Activations",
    "Carrier Account",
    "Insurance & Warranty Claims",
    "Sales in Action",
    "Call Flow Part 2",
    "Training Closing",
];

export const UNASSIGNED_GROUP_KEY = "unassigned";

export const UNASSIGNED_GROUP_LABEL = "Unassigned";

export function getLearningBlockLabel(blockNumber: number): string {
    const title = LEARNING_BLOCK_TITLES[blockNumber - 1];
    if (title === undefined) {
        return `Learning Block ${blockNumber}`;
    }
    return `Learning Block ${blockNumber}: ${title}`;
}

/** Turns a snake_case id into a spaced, start-cased label, e.g. "sales_call_flow" -> "Sales Call Flow". */
function toStartCase(value: string): string {
    return value.split("_").filter(Boolean).map(capitalizeFirstLetter).join(" ");
}

/** Label shown on a profile tile: "Block 3", "Block 3.2" when a sequence is set, or the profile's
 *  start-cased id as a fallback when it has no block assignment. */
export function getProfileBlockLabel(profile: Pick<TemplateBase, "id" | "learningBlockConfig">): string {
    const { block, blockSequence } = profile.learningBlockConfig ?? {};
    if (!block) {
        return toStartCase(profile.id);
    }
    return blockSequence ? `Block ${block}.${blockSequence}` : `Block ${block}`;
}
